export const ThaiIcon = () => (
    <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="11" cy="11.5" r="10" fill="#C4C4C4" />
        <circle cx="11" cy="11.5" r="10.5" stroke="white" strokeOpacity="0.8" />
        <mask id="mask0_11637_3412" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="1" y="1" width="20" height="21">
            <circle cx="11" cy="11.5" r="10" fill="#C4C4C4" />
        </mask>
        <g mask="url(#mask0_11637_3412)">
            <rect x="-4.4718" y="1.43304" width="30.7547" height="3.34448" fill="#F22F46" />
            <rect x="-4.47168" y="14.8109" width="30.7547" height="3.34448" fill="white" />
            <rect x="-4.47168" y="4.77747" width="30.7547" height="3.34448" fill="white" />
            <rect x="-4.47168" y="18.1555" width="30.7547" height="3.34448" fill="#F22F46" />
            <rect x="-4.47168" y="8.12192" width="30.7547" height="6.68897" fill="#0263E0" />
        </g>
    </svg>
);
